export const userStatus = {
  pending: 'pending',
  confirmed: 'confirmed',
  active: 'active'
}

export const referenceAttributesDisabled = [
  'candidate_application_accepted_accept_email',
  'candidate_application_refused_accept_email',
  'candidate_cancel_offer_accept_email',
  'recruiter_validate_subscription_accept_sms',
  'recruiter_validate_subscription_accept_push_notification'
]

export const noticeReferences =[
  'accept_email',
  'accept_push_notification',
  'accept_sms'
]



// WEBPACK FOOTER //
// ./src/settings/users.js